module.exports = __webpack_public_path__ + "img/back.5e47a860.png";